import { Room } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';

export type GetRoomParams = {
  id: string;
};
export type GetRoomResult = { room: Room.RoomDataAdminResponse };
export type GetRoomError = EndpointError;

export const getRoom = endpoint<GetRoomParams, GetRoomResult, GetRoomError>({
  method: 'GET',
  url: (params) => `/room/get-room/${params.id}`,
});
